import React from 'react'

function ResolveTicket() {
  return (
    <div>ResolveTicket</div>
  )
}

export default ResolveTicket